module.exports = __webpack_public_path__ + "static/media/note-mobile.803d678e.png";